import { useEffect as V, useRef as v } from "react";
var y = function () {
  for (var _len = arguments.length, n = new Array(_len), _key = 0; _key < _len; _key++) {
    n[_key] = arguments[_key];
  }
  let a = v(null);
  return V(() => {
    n.forEach(r => {
      !r || (typeof r == "function" ? r(a.current) : r.current = a.current);
    });
  }, [n]), a;
};
import m, { useEffect as s, useRef as T, useState as R } from "react";
import e from "prop-types";
import { allMediaTypes as L, initialize as j, teardown as w, StreamTypes as H, PlaybackTypes as I, toMuxVideoURL as M, generatePlayerInitTime as N } from "@mux/playback-core";
var k = () => {
    try {
      return "0.7.10";
    } catch {}
    return "UNKNOWN";
  },
  S = k(),
  b = () => S;
var h = b(),
  A = "mux-video-react",
  P = m.forwardRef((n, a) => {
    var d;
    let {
        playbackId: r,
        src: c,
        children: x,
        autoPlay: u,
        preload: f,
        ...E
      } = n,
      [O] = R(N()),
      [l, g] = R((d = M(r)) != null ? d : c),
      o = T(void 0),
      C = T(null),
      p = y(C, a);
    return s(() => {
      var t;
      g((t = M(r)) != null ? t : c);
    }, [c, r]), s(() => {
      let t = {
          ...n,
          src: l,
          playerInitTime: O,
          playerSoftwareName: A,
          playerSoftwareVersion: h,
          autoplay: u
        },
        i = p.current;
      return i && (o.current = j(t, i, o.current)), () => {
        w(i, o.current), i = void 0, o.current = void 0;
      };
    }, [l]), s(() => {
      var t;
      (t = o.current) == null || t.setAutoplay(u);
    }, [u]), s(() => {
      var t;
      (t = o.current) == null || t.setPreload(f);
    }, [f]), m.createElement("video", {
      ref: p,
      ...E
    }, x);
  });
P.propTypes = {
  envKey: e.string,
  debug: e.bool,
  disableCookies: e.bool,
  metadata: e.any,
  beaconCollectionDomain: e.string,
  playbackId: e.string,
  playerInitTime: e.number,
  preferPlayback: e.oneOf(Object.values(I)),
  type: e.oneOf(L),
  streamType: e.oneOf(Object.values(H)),
  startTime: e.number
};
var G = P;
export { G as default };